// extracted by mini-css-extract-plugin
export default {"header":"List_header__bCgSG","left":"List_left__XZs6B","right":"List_right__YIy0m","content":"List_content__gHMlZ","footer":"List_footer__FMUms"};